module.exports = __webpack_public_path__ + "img/hero-lines.3b74029f.svg";